import { useEffect, useState } from 'react';
import { addMonths, getUnixTime } from 'date-fns';
import useViewer from '@hooks/useViewer';

const useMyEventHistoryFilters = () => {
    const { viewer } = useViewer();
    const [filters, setFilters] = useState('');

    useEffect(() => {
        if (!viewer) {
            return;
        }

        const today = getUnixTime(new Date());
        const sixMonthsAgo = getUnixTime(addMonths(new Date(), -6));

        const eventFilters = viewer.events
            .filter(event => !!event)
            .map(event => `event_code:${event.code}`)
            .join(' OR ');

        setFilters(
            `meeting_end_timestamp < ${today} AND meeting_end_timestamp >= ${sixMonthsAgo} AND (${eventFilters})`
        );
    }, [viewer]);

    return { filters };
};

export default useMyEventHistoryFilters;
